import React from 'react'
import cn from 'classnames'
import styles from './Guilds.module.sass'
import ScrollParallax from '../../ScrollParallax'

const items = [
  {
    title: "AI & Data",
    description: "Python, Machine Learning, Deep Learning, Computer Vision, NLP, and more.",
    color: "transparent",
    image: "img/guild-ai@1.5x.png",
    image2x: "img/guild-ai@2x.png",
  },
  {
    title: "Mobile",
    description: "Swift or Kotlin hold no secret for you, or you’re maybe on the Flutter side of things?",
    color: "transparent",
    image: "img/guild-mobile@1.5x.png",
    image2x: "img/guild-mobile@2x.png",
    status: "blue",
    statusContent: "New",
  },
  {
    title: "Front-end",
    description: "JavaScript and its newest standard is second nature to you.",
    color: "transparent",
    image: "img/guild-front@1.5x.png",
    image2x: "img/guild-front@2x.png",
    status: "blue",
    statusContent: "New",
  },
  {
    title: "Back-end",
    description: "If things outside of a browser look fine to you.",
    color: "transparent",
    image: "img/guild-back@1.5x.png",
    image2x: "img/guild-back@2x.png",
    status: "blue",
    statusContent: "New",
  },
  {
    title: "DevOps",
    description: "AWS, Kubernetes, CI/CD pipelines, and everything that make code scale.",
    color: "transparent",
    image: "img/guild-devops@1.5x.png",
    image2x: "img/guild-devops@2x.png",
    status: "blue",
    statusContent: "New",
  },
  {
    title: "Blockchain",
    description: "You were into Solidity and smart contreacts before web3 was even a thing.",
    color: "transparent",
    image: "img/guild-blockchain@1.5x.png",
    image2x: "img/guild-blockchain@2x.png",
    status: "purple",
    statusContent: "Coming Soon",
  },
]

export const Guilds = () => {
  return (
    <>
      <div className={cn("section-border-top", styles.section)}>
        <div className={cn("container", styles.container)}>
          <h2 className={cn("h2", styles.title)}>Join a guild within <br />your skillset</h2>
          <div className={styles.info}>
            Earn by helping out peers in tech
          </div>
          <div className={styles.list}>
            {items.map((x, index) => (
              <ScrollParallax className={styles.item} key={index}>
                <div
                  className={styles.preview}
                  style={{ backgroundColor: x.color }}
                >
                  <img src={x.image} srcSet={x.image2x + ` 2x`} alt={x.title} />
                </div>
                <div className={styles.details}>
                  {x.status && (
                    // <div className={cn(x.status, styles.status)}>{x.statusContent}</div>
                    <div
                      className={cn(
                        { "status-stroke-black": x.status === "black" },
                        { "status-blue": x.status === "blue" },
                        { "status-purple": x.status === "purple" },
                        styles.status
                      )}
                    >
                      {x.statusContent}
                    </div>
                  )}
                  <div className={styles.subtitle}>{x.title}</div>
                  <div className={styles.description}>{x.description}</div>
                </div>
              </ScrollParallax>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Guilds
